import { SelectBox } from 'devextreme-react';
import React from 'react';
import _ from 'lodash';

export const FormSelect = ({ field, form: { touched, errors, setFieldValue }, ...props }) => {
  const { col, label, help, onChange, required } = props;
  return (
    <div className={`col-lg-${col}`}>
      <div className={`form-group ${_.get(errors, field.name) ? 'has-error' : null}`}>
        <label className="control-label">
          {label}
          {help && (
            <span data-toggle="tooltip" data-placement="top" title={help}>
              <i className="fa fa-question-circle" />
            </span>
          )}
        </label>
        {required && <span className="text-danger"> * </span>}
        <SelectBox
          {...field}
          {...props}
          isValid={!_.get(errors, field.name)}
          onValueChanged={option => {
            setFieldValue(field.name, option ? option.value : '');

            onChange && onChange(option);
          }}
        />

        {_.get(touched, field.name) && _.get(errors, field.name) && (
          <small className="help-block m-b-none">{_.get(errors, field.name)}</small>
        )}
      </div>
    </div>
  );
};
